import { Stack, Text, Label, Dropdown } from '@fluentui/react';
import { useLanguageGridConfig } from '../../hooks/useLanguageSettings';

export const LanguageGridConfig = () => {
    const { currentLanguage, handleLanguageChange, dropdownOptions } = useLanguageGridConfig();

    return (
        <Stack tokens={{ padding: 10, childrenGap: 10 }}>
            <Text variant="large">Language settings (Preview)</Text>
            <Label>Choose the default app language</Label>
            <Dropdown
                placeholder="Select a language"
                options={dropdownOptions}
                onChange={handleLanguageChange}
                selectedKey={currentLanguage}
                styles={{
                    root: { maxWidth: 250 },
                }}
            />
        </Stack>
    );
};
